module.exports = __webpack_public_path__ + "img/airtke_power.a45e444f.jpg";